import { lazy } from 'react';

// How long to wait before re-requesting a failed chunk. Long enough for a
// dropped mobile-data connection to re-establish, short enough that the user
// is still looking at the Suspense fallback rather than a frozen page.
const RETRY_DELAY_MS = 1500;

/**
 * React.lazy caches a rejected import forever — after one dropped chunk
 * request (routine on mobile data), every later render of that route re-throws
 * the cached failure and dead-ends at the ErrorBoundary until a full page
 * reload. Retrying the import once inside the factory means the cached promise
 * only settles as failed after two attempts, which absorbs transient drops.
 *
 * Drop-in replacement: `lazyWithRetry(() => import('./pages/Foo'))`.
 */
const lazyWithRetry = (importer) =>
  lazy(() =>
    importer().catch(
      () =>
        new Promise((resolve) => setTimeout(resolve, RETRY_DELAY_MS)).then(importer)
    )
  );

export default lazyWithRetry;
